import React, { useState, useEffect } from 'react'

import { Routes, Route, MemoryRouter, useNavigate } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'

import './App.css'
import { FirebaseMessagingTokenContext, getMessagingToken } from './firebase'

import Conversations from './features/Conversations.js'
import Markers from './features/Markers.js'
import Scenes from './features/Scenes.js'
import GlobalCooldown from './features/global_cooldown/components/GlobalCooldown.js'
import FreePlayTeaser from './features/global_cooldown/components/FreePlayTeaser.js'
import DebugPanel from './features/debug/DebugPanel.js'
import Settings from './features/settings/components/Settings.js'
import FreePlayTimeOfDay from './features/settings/components/FreePlayTimeOfDay.js'

import { Button, Dialog, Modal } from 'react-aria-components'

import { selectIsCoolingDown } from './features/global_cooldown/globalCooldownSlice.js'
import { selectHasGameStarted, selectIsNoDelay, setGameHasStarted, setTimescaleMode, setNoDelayMode, setUseNotifications, setNoNotification } from './features/settings/settingsSlice.js'

import Intro from './intro'
import Splash from './splash'
import Permissions from './permissions'
import Map from './map/Map.js'
import FloatingFeedback from './feedback/FloatingFeedback.js'

function App () {
  // TODO where does this live now?
  const [token, setToken] = useState(null)
  if (!token) {
    getMessagingToken().then(token => {
      setToken(token)
    })
  }

  return (
    <FirebaseMessagingTokenContext.Provider value={token}>
      <div className='flex'>
        <MemoryRouter>
          <Routes>
            <Route path='/' element={<Splash />} />
            <Route path='/mode' element={<ChooseFreePlayOrTimescaleMode />} />
            <Route path='/notifications' element={<NotificationsSelection />} />
            <Route path='/permissions' element={<Permissions />} />
            <Route path='/game' element={<Game />} />
          </Routes>
        </MemoryRouter>
      </div>
    </FirebaseMessagingTokenContext.Provider>
  )
}

// TODO:
// factor out these components
// Use the reader style component for the permissions screen as well
// the "intro" component is dead maybe?
// double check responsive styling of the reader it looked wide on desktop
//
const buttonStyle = 'mt-10 mx-2 p-3 border-2 bg-green-200 outline-black border-solid border rounded-sm'

function ChooseFreePlayOrTimescaleMode () {
  const hasGameStarted = useSelector(selectHasGameStarted)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    if (hasGameStarted) {
      navigate('/game')
    }
  }, [hasGameStarted, navigate])

  const selectTimescaleMode = () => {
    dispatch(setTimescaleMode())
    navigate('/notifications')
  }
  const selectFreePlayMode = () => {
    dispatch(setNoDelayMode())
    navigate('/game')
  }

  const onClose = () => console.log('fuck')

  const content = (
    <div className=''>
      <h1 className='text-3xl'>This is a Timescale Story</h1>

      <div>If you choose "Free Play" mode, you can play through the story as fast as you want, with no Timescale</div>
      <div className='mt-2 font-bold'>Competition judges: please select Free Play mode.</div>
      <button onClick={selectFreePlayMode} className="mt-1 mb-3 mx-2 p-3 border-2 bg-green-200 outline-black border-solid border rounded-sm">Free Play</button>

      <div>Timescale mode is not for the IF comp. But it is the intended gameplay where the story's timescale is across weeks. It's in alpha but feel free play and leave feedback</div>
      <button onClick={selectTimescaleMode} className="mt-1 mb-3 mx-2 p-3 border-2 bg-orange-200 outline-black border-solid border rounded-sm">Timescale (alpha)</button>
    </div>
  )

  const reader = (
    <Modal isOpen isDismissable={false} className='flex z-1000 fixed top-0 h-screen w-screen'>
      <div className='flex-1 backdrop-blur-xs' />
      <Dialog className='flex-11 md:flex-3 bg-white p-1 h-100% overflow-scroll'>
        <div className='font-mono h mx2'>
          {content}
        </div>
        <div className='h-20' />
      </Dialog>
      <div className='flex-1 backdrop-blur-xs' />
    </Modal>
  )

  return (
    <>
      {reader}

      <Map />
    </>
  )
}

function NotificationsSelection () {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const selectNoNotifications = () => {
    dispatch(setNoNotification())
    navigate('/game')
  }
  const selectNotifications = () => {
    dispatch(setUseNotifications())
    navigate('/permissions')
  }

  return (
    <div>
      <h1 className='text-3xl'>Choose notifications</h1>

      <div>You can choose to receive a notification on your device when you're able to continue in the game.</div>

      <button onClick={selectNoNotifications} className={buttonStyle}>No Notification</button>
      <button onClick={selectNotifications} className={buttonStyle}>Notifications</button>
    </div>
  )
}

function Game () {
  const isCoolingDown = useSelector(selectIsCoolingDown)
  const isNoDelay = useSelector(selectIsNoDelay)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setGameHasStarted())
  }, [dispatch])

  return (
    <>
      <Settings />
      <FreePlayTimeOfDay />
      <Scenes />
      <Conversations />
      <GlobalCooldown />
      <FreePlayTeaser />

      {!isNoDelay && (process.env.NODE_ENV === 'development' ||
        process.env.REACT_APP_SHOW_DEBUG === 'true') && <DebugPanel />}

      <Map>
        {!!isCoolingDown || <Markers />}
      </Map>

      <FloatingFeedback />
    </>
  )
}

export default App
